/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassLocationFull,
  ClassLocationFullOptional,
  ClassLocationFullMetaI,
  ClassLocationFullTrackedI,
} from "./class-location-full";
import {
  ClassLocationFullTracked,
  ClassLocationFullMeta,
} from "./class-location-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassInstanceRef,
  JpClassInstanceRefOptional,
  JpClassInstanceRefMetaI,
  JpClassInstanceRefTrackedI,
} from "./jp-class-instance-ref";
import {
  JpClassInstanceRefTracked,
  JpClassInstanceRefMeta,
} from "./jp-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSectionFull,
  JpClassSectionFullOptional,
  JpClassSectionFullMetaI,
  JpClassSectionFullTrackedI,
} from "./jp-class-section-full";
import {
  JpClassSectionFullTracked,
  JpClassSectionFullMeta,
} from "./jp-class-section-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSectionLookupFull,
  JpClassSectionLookupFullOptional,
  JpClassSectionLookupFullMetaI,
  JpClassSectionLookupFullTrackedI,
} from "./jp-class-section-lookup-full";
import {
  JpClassSectionLookupFullTracked,
  JpClassSectionLookupFullMeta,
} from "./jp-class-section-lookup-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfoAndRef,
  PersonNameInfoAndRefOptional,
  PersonNameInfoAndRefMetaI,
  PersonNameInfoAndRefTrackedI,
} from "./person-name-info-and-ref";
import {
  PersonNameInfoAndRefTracked,
  PersonNameInfoAndRefMeta,
} from "./person-name-info-and-ref";

/**
 *
 * @export
 * @interface ClassSectionDTO
 */
export interface ClassSectionDTOOptional extends JpClassSectionFullOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSectionDTO
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof ClassSectionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSectionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  createdBy?: string;
  /**
   *
   * @type {JpClassInstanceRef}
   * @memberof ClassSectionDTO
   */
  instanceId?: JpClassInstanceRefOptional;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof ClassSectionDTO
   */
  instructorId?: PersonNameInfoAndRefOptional;
  /**
   *
   * @type {ClassLocationFull}
   * @memberof ClassSectionDTO
   */
  locationId?: ClassLocationFullOptional;
  /**
   *
   * @type {JpClassSectionLookupFull}
   * @memberof ClassSectionDTO
   */
  lookupId?: JpClassSectionLookupFullOptional;
}

export interface ClassSectionDTO
  extends ClassSectionDTOOptional, JpClassSectionFull {
  /**
   *
   * @type {number}
   * @memberof ClassSectionDTO
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof ClassSectionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSectionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  createdBy?: string;
  /**
   *
   * @type {JpClassInstanceRef}
   * @memberof ClassSectionDTO
   */
  instanceId?: JpClassInstanceRef;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof ClassSectionDTO
   */
  instructorId?: PersonNameInfoAndRef;
  /**
   *
   * @type {ClassLocationFull}
   * @memberof ClassSectionDTO
   */
  locationId?: ClassLocationFull;
  /**
   *
   * @type {JpClassSectionLookupFull}
   * @memberof ClassSectionDTO
   */
  lookupId?: JpClassSectionLookupFull;
}

export interface ClassSectionDTOTrackedI extends JpClassSectionFullOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSectionDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSectionDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSectionDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSectionDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {JpClassInstanceRef}
   * @memberof ClassSectionDTO
   */
  instanceId?: JpClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof ClassSectionDTO
   */
  instructorId?: PersonNameInfoAndRefTrackedI;
  instructorIdIsSet: boolean;
  /**
   *
   * @type {ClassLocationFull}
   * @memberof ClassSectionDTO
   */
  locationId?: ClassLocationFullTrackedI;
  locationIdIsSet: boolean;
  /**
   *
   * @type {JpClassSectionLookupFull}
   * @memberof ClassSectionDTO
   */
  lookupId?: JpClassSectionLookupFullTrackedI;
  lookupIdIsSet: boolean;
}

transformDatesMap.set("ClassSectionDTO", function (model: ClassSectionDTO) {
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  const transformDatesinstanceId = transformDatesMap.get("JpClassInstanceRef");
  if (transformDatesinstanceId && model.instanceId) {
    transformDatesinstanceId(model.instanceId);
  }
  const transformDatesinstructorId = transformDatesMap.get(
    "PersonNameInfoAndRef",
  );
  if (transformDatesinstructorId && model.instructorId) {
    transformDatesinstructorId(model.instructorId);
  }
  const transformDateslocationId = transformDatesMap.get("ClassLocationFull");
  if (transformDateslocationId && model.locationId) {
    transformDateslocationId(model.locationId);
  }
  const transformDateslookupId = transformDatesMap.get(
    "JpClassSectionLookupFull",
  );
  if (transformDateslookupId && model.lookupId) {
    transformDateslookupId(model.lookupId);
  }
});

export type ClassSectionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<JpClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  instructorId: PropertyMeta<PersonNameInfoAndRefMetaI>;
  //isDate: false
  //isDatetime: false
  locationId: PropertyMeta<ClassLocationFullMetaI>;
  //isDate: false
  //isDatetime: false
  lookupId: PropertyMeta<JpClassSectionLookupFullMetaI>;
}>;

export var ClassSectionDTOMeta: ClassSectionDTOMetaI =
  {} as ClassSectionDTOMetaI;
ClassSectionDTOMeta = typeMeta("ClassSectionDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    JpClassInstanceRefMeta,
  ),
  instructorId: propertyMeta(
    "instructorId",
    false,
    false,
    false,
    PersonNameInfoAndRefMeta,
  ),
  locationId: propertyMeta(
    "locationId",
    false,
    false,
    false,
    ClassLocationFullMeta,
  ),
  lookupId: propertyMeta(
    "lookupId",
    false,
    false,
    false,
    JpClassSectionLookupFullMeta,
  ),
});

const metaI = ClassSectionDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([JpClassSectionFullMeta]);
  metaI.assignId.inheritedFrom = JpClassSectionFullMeta.assignId;
  metaI.isDeleted.inheritedFrom = JpClassSectionFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = JpClassSectionFullMeta.isNew;
  metaI.updatedOn.inheritedFrom = JpClassSectionFullMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = JpClassSectionFullMeta.updatedBy;
  metaI.createdOn.inheritedFrom = JpClassSectionFullMeta.createdOn;
  metaI.createdBy.inheritedFrom = JpClassSectionFullMeta.createdBy;
  metaI.instanceId.inheritedFrom = JpClassSectionFullMeta.instanceId;
  metaI.instructorId.inheritedFrom = JpClassSectionFullMeta.instructorId;
  metaI.locationId.inheritedFrom = JpClassSectionFullMeta.locationId;
  metaI.lookupId.inheritedFrom = JpClassSectionFullMeta.lookupId;
});

export class ClassSectionDTOTracked
  extends JpClassSectionFullTracked
  implements ClassSectionDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  instanceId__I?: JpClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | JpClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  instructorId__I?: PersonNameInfoAndRefTracked = undefined;
  instructorIdIsSet: boolean = false;
  set instructorId(v: undefined | PersonNameInfoAndRefTracked) {
    if (v !== undefined) {
      this.instructorId__I = v;
      this.instructorIdIsSet = true;
    } else {
      this.instructorId__I = v || undefined;
      this.instructorIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructorId() {
    return this.instructorId__I;
  }
  locationId__I?: ClassLocationFullTracked = undefined;
  locationIdIsSet: boolean = false;
  set locationId(v: undefined | ClassLocationFullTracked) {
    if (v !== undefined) {
      this.locationId__I = v;
      this.locationIdIsSet = true;
    } else {
      this.locationId__I = v || undefined;
      this.locationIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get locationId() {
    return this.locationId__I;
  }
  lookupId__I?: JpClassSectionLookupFullTracked = undefined;
  lookupIdIsSet: boolean = false;
  set lookupId(v: undefined | JpClassSectionLookupFullTracked) {
    if (v !== undefined) {
      this.lookupId__I = v;
      this.lookupIdIsSet = true;
    } else {
      this.lookupId__I = v || undefined;
      this.lookupIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get lookupId() {
    return this.lookupId__I;
  }
  constructor(config?: ClassSectionDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.instanceId?.setIds();

    this.instructorId?.setIds();

    this.locationId?.setIds();

    this.lookupId?.setIds();
  }
  assignFrom(
    config: ClassSectionDTOOptional,
    options?: AssignOptions,
  ): ClassSectionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new JpClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (
      config.instructorId &&
      this.instructorIdApplyFilter(optionsRequired.filter)
    ) {
      this.instructorId = new PersonNameInfoAndRefTracked(
        config.instructorId,
        options,
      );
      if (optionsRequired.unassign) this.instructorIdIsSet = false;
      else this.instructorIdIsSet = true;
    }
    if (
      config.locationId &&
      this.locationIdApplyFilter(optionsRequired.filter)
    ) {
      this.locationId = new ClassLocationFullTracked(
        config.locationId,
        options,
      );
      if (optionsRequired.unassign) this.locationIdIsSet = false;
      else this.locationIdIsSet = true;
    }
    if (config.lookupId && this.lookupIdApplyFilter(optionsRequired.filter)) {
      this.lookupId = new JpClassSectionLookupFullTracked(
        config.lookupId,
        options,
      );
      if (optionsRequired.unassign) this.lookupIdIsSet = false;
      else this.lookupIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassSectionDTOTrackedI {
    const cloned = {} as ClassSectionDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.instructorIdIsSetDeep() &&
      this.instructorIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorIdIsSet = true;
      cloned.instructorId = this.instructorId?.removeUnset(filter);
    } else {
      //cloned.instructorIdIsSet = false
    }
    if (
      this.locationIdIsSetDeep() &&
      this.locationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationIdIsSet = true;
      cloned.locationId = this.locationId?.removeUnset(filter);
    } else {
      //cloned.locationIdIsSet = false
    }
    if (
      this.lookupIdIsSetDeep() &&
      this.lookupIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lookupIdIsSet = true;
      cloned.lookupId = this.lookupId?.removeUnset(filter);
    } else {
      //cloned.lookupIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassSectionDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.instructorIdApplyFilter(filter)) this.instructorIdIsSet = false;
    this.instructorId?.unassignAll(filter);

    if (!this.locationIdApplyFilter(filter)) this.locationIdIsSet = false;
    this.locationId?.unassignAll(filter);

    if (!this.lookupIdApplyFilter(filter)) this.lookupIdIsSet = false;
    this.lookupId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.assignId,
      ClassSectionDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.isDeleted,
      ClassSectionDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.isNew,
      ClassSectionDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.updatedOn,
      ClassSectionDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.updatedBy,
      ClassSectionDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.createdOn,
      ClassSectionDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.createdBy,
      ClassSectionDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.instanceId,
      ClassSectionDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  instructorIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.instructorId,
      ClassSectionDTOMeta,
      this.instructorId,
      this,
    );
  }
  instructorIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instructorIdIsSet && this.instructorIdApplyFilter(filter))
      return true;
    return this.instructorId?.anySet(filter) == true;

    return false;
  }
  locationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.locationId,
      ClassSectionDTOMeta,
      this.locationId,
      this,
    );
  }
  locationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationIdIsSet && this.locationIdApplyFilter(filter)) return true;
    return this.locationId?.anySet(filter) == true;

    return false;
  }
  lookupIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSectionDTOMeta.lookupId,
      ClassSectionDTOMeta,
      this.lookupId,
      this,
    );
  }
  lookupIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lookupIdIsSet && this.lookupIdApplyFilter(filter)) return true;
    return this.lookupId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.instructorIdIsSetDeep(filter)) return true;
    if (this.locationIdIsSetDeep(filter)) return true;
    if (this.lookupIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
